import { find } from 'lodash/fp';

import { BreakpointRange } from './BreakpointRange';
import { BreakpointRangeValue } from './types';

export const atMost =
    (upperBound: BreakpointRangeValue) =>
    (range: BreakpointRangeValue): boolean =>
        range.high <= upperBound.high;

export const atLeast =
    (lowerBound: BreakpointRangeValue) =>
    (range: BreakpointRangeValue): boolean =>
        lowerBound.low <= range.low;

export const matchesBreakpointRange = (b: BreakpointRangeValue) =>
    window.matchMedia(`(min-width: ${b.low}px) and (max-width: ${b.high}px)`).matches;

export const getBreakpointRange = (): BreakpointRangeValue =>
    find(matchesBreakpointRange, BreakpointRange) || BreakpointRange.Phone;

export const isAtMostMobile = atMost(BreakpointRange.Phone);
export const isAtMostTablet = atMost(BreakpointRange.Tablet);
export const isAtLeastTablet = atLeast(BreakpointRange.Tablet);

export const mediaMinWidth = (breakpointRange: BreakpointRangeValue) => `@media (min-width: ${breakpointRange.low}px)`;
export const mediaMaxWidth = (breakpointRange: BreakpointRangeValue) => `@media (max-width: ${breakpointRange.high}px)`;
